import React, { useEffect, useState } from 'react'
import MyButton from '../../../../UI/form/MyButton'
import { addValueObjInArrayForm, checkValid, deleteObjInArrayForm, deleteValidateById, updateValidate, updateValidateInArrayForm, updateValueObjInArrayForm } from '../../../../../helpers/form/FormHelper'
import WriteOffActFormItem from './WriteOffActFormItem'

const WriteOffActFormItems = ({ departmentId, required, setValidate, setValueForm, forciblyValue }) => {

	const [writeOffActItems, setWriteOffActItems] = useState(forciblyValue ? forciblyValue : [])
	const [disabled, setDisabled] = useState(false)

	const [valid, setValid] = useState({}) // Валідація кожного поля
	const [isCanDeleted, setIsCanDeleted] = useState(false) // Можливість видалення
  	// Тут скоріш за все реалізувати позиції через стор. 

	// console.log('writeOffActItems', writeOffActItems)
	// console.log('valid', valid)

	useEffect(() => {
		validMaxItems()
		changeIsCanDeleted()
		setValueForm(writeOffActItems)
	}, [writeOffActItems])

	useEffect(() => {
		// checkValid(valid, setIsValidForm)
		checkValid(valid, setValidate)
	}, [valid])

	useEffect(() => { // За замовчуванням додаємо перший елемент завжди
		if (writeOffActItems && writeOffActItems.length === 0) {
			addValueObjInArrayForm(setWriteOffActItems, {})
		}
	}, [])

	useEffect(() => {
		if (writeOffActItems && writeOffActItems.length > 0) {
			setWriteOffActItems([]) // Обнуляємо позиції при зміні підрозділу
			addValueObjInArrayForm(setWriteOffActItems, {}) // Й додаємо новий порожній елемент
		}
	}, [departmentId])

	const addItem = () => {
		// addValueInArrayForm(setWriteOffActItems, {id: 'fsdfdsf'})
		addValueObjInArrayForm(setWriteOffActItems, {})
		// setWriteOffActItems([{}])
		setDisabled(false)
	}

	const validMaxItems = () => { // Заборона на внесення більше 10 позицій
		// if (writeOffActItems && writeOffActItems.length >= 10) {
		if (writeOffActItems && writeOffActItems.length >= 300) {
			setDisabled(true)
		} else {
			setDisabled(false)
		}
	}

	const changeIsCanDeleted = () => { // Заборона на внесення більше 10 позицій
		if (writeOffActItems && writeOffActItems.length > 1) {
			setIsCanDeleted(true)
		} else {
			setIsCanDeleted(false)
		}
	}

  return (
    <div className='myFormSimple__listBlock'>
		{
			writeOffActItems && writeOffActItems.length > 0 ?
				writeOffActItems.map((writeOffActItem, index) => {
					return (
						<WriteOffActFormItem 
							key={writeOffActItem.id}
							index={index}
							departmentId={departmentId}
							writeOffActItem={writeOffActItem}
							// setValidate={e => updateValidateInArrayForm(setValid, writeOffActItem.id, e)}
							setValidate={e => updateValidate(setValid, writeOffActItem.id, e)}
							setValueFormItem={e => updateValueObjInArrayForm(setWriteOffActItems, writeOffActItem.id, e)}
							// forciblyValue={writeOffActItem ? writeOffActItem : ''}
							deleteItem={e => {
								deleteObjInArrayForm(setWriteOffActItems, writeOffActItem.id)
								deleteValidateById(setValid, writeOffActItem.id)
							}}
							isCanDeleted={isCanDeleted}
						/>
					)
				})
			: ''
		}
		<MyButton
			onClick={e => {
				setDisabled(true)
				addItem()
			}}
			disabled={disabled}
		>
			Додати позицію
		</MyButton>
    </div>
  )
}

export default WriteOffActFormItems